// extracted by mini-css-extract-plugin
export default {"productDescription":"Xaa-z","featuredDescription":"Yaa-z","description":"Zaa-z","more":"_aa-z","descriptionSku":"aba-z"};